import { GameAssets, ImageAssets } from '../../utils/enums/assets';
import { BreackpointsX, BreackpointsY } from '../../utils/enums/breackpoints';
import { Image } from '../../utils/types/gameObjects';

import { UIController } from './uiController';

export class UiImages {
  static Background(context: Phaser.Scene, isLoading?: boolean): Image {
    const [w, h] = UIController.widthHeight(context);
    let scale = 1;

    if (w <= BreackpointsX.LAPTOP || h <= BreackpointsY.LG) {
      scale = 0.75;
    }
    if (w <= BreackpointsX.TABLET) {
      scale = 0.52;
    }

    const bg = context.add
      .image(0, 0, isLoading ? ImageAssets.LOADING_BACKGROUND : ImageAssets.BACKGROUND)
      .setOrigin(0.5, 1)
      .setPosition(w / 2, h);

    if (w <= BreackpointsX.LAPTOP) {
      bg.setScale(scale);
    }

    return bg;
  }

  static Player(context: Phaser.Scene) {
    const [w, h] = UIController.widthHeight(context);
    const [x] = UIController.centerXY(context);

    let scale = 1;

    if (w <= BreackpointsX.LAPTOP || h <= BreackpointsY.LG) {
      scale = 0.6;
    }
    if (w <= BreackpointsX.TABLET) {
      scale = 0.4;
    }
    if (w <= BreackpointsX.MOBILE_SM) {
      scale = 0.2;
    }

    return context.physics.add
      .image(x, h, GameAssets.PLAYER_DEFAULT)
      .setOrigin(0.5, 1)
      .setScale(scale);
  }
}
